import React, { useSyncExternalStore } from "react";
import { Box, Fade, LinearProgress } from "@mui/material";
import { useMessage } from "../i18n/locale";
import {
  getActiveRequestCount,
  subscribeToRequestActivity,
} from "../services/apiClient";

export default function NetworkProgress() {
  const activeRequests = useSyncExternalStore(
    subscribeToRequestActivity,
    getActiveRequestCount,
    getActiveRequestCount
  );
  const loadingLabel = useMessage("loadingContent");
  const loading = activeRequests > 0;

  return (
    <Fade in={loading} timeout={{ enter: 140, exit: 240 }} unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          insetBlockStart: 0,
          insetInline: 0,
          zIndex: (theme) => theme.zIndex.tooltip + 1,
          pointerEvents: "none",
        }}
      >
        <LinearProgress
          aria-label={loadingLabel}
          sx={{
            height: 3,
            "& .MuiLinearProgress-bar": {
              transition: "transform 240ms ease-out",
            },
          }}
        />
      </Box>
    </Fade>
  );
}
